import axiosClient from "@/libs/axiosClient";

export const getSystemFrontendConfig = () => {
    return axiosClient.get(`/system/frontendconfigs`);
};

export const updateSystemFrontendConfig = (data) => {
    return axiosClient.post(`/system/frontendconfigs/update`, data);
};

export const getMaxRecordLb = (options) => {
    return axiosClient.get(`/system/backendconfigs/maxrecordlb?recordType=${options.recordType}`);
};

export const getMaxSubdomainLength = (options) => {
    return axiosClient.get(`/system/backendconfigs/maxsubdomainlength`);
};

export const getPlatformPlan = ({ groupName } = {}) => {
    return axiosClient.get(`/system/platformplan?groupName=${groupName}`);
};

export const getLicenseInfo = () => {
    return axiosClient.get(`/system/license-information`);
};

export const getLicenseInfoOption = () => {
    return axiosClient.get(`/system/license-information/select-options`);
};

export const updateLicenseInfoOption = (data) => {
    return axiosClient.post(`/system/license-information`, data);
};

export const getToken = () => {
    return axiosClient.get(`/system/token-information`);
};

export const checkToken = ({ token } = {}) => {
    return axiosClient.get(`/system/token-information/checkToken?token=${token}`);
};

export const updateToken = (data) => {
    return axiosClient.post(`/system/token-information`, data);
};

export const _createApiToken = () => {
    return axiosClient.post(`/system/token-information/apiToken`);
};

export const _getDecryptApiToken = (apiToken) => {
    return axiosClient.get(`/system/token-information/decryptApiToken/${apiToken}`);
};

export const _groupUsage = (data) => {
    return axiosClient.get(
        `/system/groupUsage?groupName=${data.groupName}&sDate==${data.customTimeRange[0]}&eDate=${data.customTimeRange[1]}`
    );
};



// WEBPACK FOOTER //
// ./src/api/system.js